import { render, staticRenderFns } from "./Laborer.vue?vue&type=template&id=676f100c&scoped=true&"
import script from "./Laborer.vue?vue&type=script&lang=js&"
export * from "./Laborer.vue?vue&type=script&lang=js&"
import style0 from "./Laborer.vue?vue&type=style&index=0&id=676f100c&lang=less&scoped=true&"
import style1 from "./Laborer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f100c",
  null
  
)

export default component.exports